import React, { useCallback } from "react";
import PropTypes from "prop-types";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";

const query = `
  query AssetCategories {
    assetCategories {
      items {
        id
        name
        codename
      }
      total
    }
  }
`;

const AssetCategorySelect = ({
  id = "assetCategory",
  name = "assetCategory",
  defaultCategories,
  multiple,
  ...props
}) => {
  const handleDataFromResponse = useCallback(data => data.assetCategories, []);
  const handleGetValue = useCallback(element => element.id, []);
  const handleGetLabel = useCallback(element => element.name, []);

  const defaultValueHandler = elements =>
    elements ? elements.items.filter(e => defaultCategories.includes(e.codename)).map(cat => cat.id) : [];

  return (
    <EntitiesSelector
      id={id}
      name={name}
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      multiple={multiple}
      getMultipleDefaultValue={defaultCategories ? defaultValueHandler : null}
      {...props}
    />
  );
};

AssetCategorySelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del selector
   */
  selectedElement: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Valor del selector
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default AssetCategorySelect;
